


























































































import Vue, { PropOptions } from 'vue';
import PageListContent from '@/components/bots/PageListContent.vue';
import ModalCreateNewBot from '@/components/bots/ModalCreateNewBot.vue';

export default Vue.extend({
  components: { PageListContent, ModalCreateNewBot },
  async mounted() {
    await this.$store.dispatch('loadBotDefaultTeam');
    await this.$store.dispatch('loadTeams');
    await this.$store.dispatch('loadBots');
    await this.$store.dispatch('loadBotDefaultTrandingHours');
  },
  data() {
    return {
      bot: {
        type: Object,
      },
      showCreate: false,
      loading: false,
      item: null,
      items: [
        {
          id: 'blank',
          text: 'Em branco',
          subtitle: 'Comece um bot novo sem template',
          icon: 'mdiSelect',
          class: 'mt2',
        },
      ],
    };
  },
  methods: {
    newBot(op: string) {
      switch (op) {
        case 'redirectToTeam':
          // this.newToTeamBot();
          break;
        case 'faq':
          // this.newFaqBot();
          break;
        default:
          this.newBlankBot();
          break;
      }
    },
    // newToTeamBot() {},
    // newFaqBot() {},
    newBlankBot() {
      this.onShowDialog();
    },
    onShowDialog() {
      (this as any).bot = undefined;
      (this as any).showCreate = true;
    },
    onCloseDialog() {
      (this as any).showCreate = false;
    },
    onUpdateBot() {
      this.onCloseDialog();
    },
  },
  watch: {
    '$store.state.team.teams'(val) {
      this.teams = val;
    },
  },
});
